module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.code || _vm.code <= 0) ? _c('div', {
    staticClass: "w5-error-page"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.message)),
      expression: "localeFtc(message)"
    }]
  })])]) : (_vm.code === 404) ? _c('notFoundPage') : _c('error503', {
    attrs: {
      "response": _vm.Response
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82f686c4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/errorPage.vue
// module id = 777
// module chunks = 0